import { Component } from "react";
import PropTypes from "prop-types";
import Modal from "@shared/v2/Modal";
import { IncomeExpenseForm } from "../shared/IncomeExpenseForm";
import { reCalculateAgentExpenses } from "../shared/FinancialViewHelpers";
import Error from "../../../shared/Error";

class ExpenseModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      value: "",
      percentage: true,
      // eslint-disable-next-line react/no-unused-state
      expense_amount: "",
      // eslint-disable-next-line react/no-unused-state
      type: "expense",
      // eslint-disable-next-line react/no-unused-state
      agent_expense_type_id: "",
      position: "",
      isNotValid: false,
      errMsg: "",
    };
  }

  saveExpenseData = () => {
    const { name, value, percentage } = this.state;
    if (name && value) {
      if (percentage) {
        if (value >= 0 && value <= 100) {
          this.saveData();
        } else {
          this.setState({
            errMsg: "Value must be between 0 and 100.",
            isNotValid: true,
          });
        }
      } else {
        this.saveData();
      }
    } else {
      this.setState({
        errMsg: "Enter a name and value.",
        isNotValid: true,
      });
    }
  };

  saveData() {
    const { percentage, value } = this.state;
    const { listingData, modalIndex, setFinancial, setIsExpenseModal } = this.props;

    if (!percentage) {
      if (value === "") {
        this.state.value = 0;
      }
    }
    const income = listingData.team_member_incomes.incomes[modalIndex];
    const nonDeletedCustomExpenses = income.custom_team_member_expenses_attributes.filter(
      // eslint-disable-next-line no-underscore-dangle
      (expense) => expense._destroy !== "1",
    );

    this.state.position = nonDeletedCustomExpenses.length
      ? nonDeletedCustomExpenses[nonDeletedCustomExpenses.length - 1].position + 1
      : 1;
    this.state.value *= 1;
    income.custom_team_member_expenses_attributes.push(this.state);
    reCalculateAgentExpenses(income, listingData, modalIndex, setFinancial);
    setIsExpenseModal(false);
  }

  render() {
    const { isExpenseModal, setIsExpenseModal, listingData } = this.props;
    const { isNotValid, errMsg } = this.state;

    return (
      <Modal
        show={isExpenseModal}
        onHide={() => setIsExpenseModal(false)}
        dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
        contentClassName="tw-max-w-[640px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
      >
        <Modal.Header
          description="This is unique to this transaction and will not be repeated"
          title="New Expense"
          closeButton
        />

        <Modal.Body className="tw-flex tw-flex-col tw-gap-[24px]">
          {isNotValid && <Error errorMessage={errMsg} />}

          <IncomeExpenseForm
            modalThis={this}
            expList={listingData.agent_expense_types}
            setIsOpenNewIncomeModal={setIsExpenseModal}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

ExpenseModal.propTypes = {
  listingData: PropTypes.shape({
    agent_expense_types: PropTypes.arrayOf(PropTypes.shape()),
    team_member_incomes: PropTypes.shape(),
  }).isRequired,
  modalIndex: PropTypes.number.isRequired,
  setFinancial: PropTypes.func.isRequired,
  setIsExpenseModal: PropTypes.func.isRequired,
  isExpenseModal: PropTypes.bool.isRequired,
};

export default ExpenseModal;
